import { GetCommittedOrderRequest } from './../../../core/domain/requests/committed-order/get-committed-order.request';
import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { BaseState } from '../../base/state/base.state';
import { CommittedOrder } from './../../../core/domain/models/committed-order';
import { SetCommittedOrders, SetCommittedOrdersRequest } from './committed-orders.actions';

export class CommittedOrdersStateModel {
  committedOrders: CommittedOrder[] | undefined;
  committedOrdersRequest : any | undefined

}

const defaults = {
  committedOrders: undefined,
  committedOrdersRequest : undefined
};

@State<CommittedOrdersStateModel>({
  name: 'committedOrders',
  defaults,
})
@Injectable()
export class CommittedOrdersState extends BaseState {
  constructor() {
    super();
  }

  @Action(SetCommittedOrders)
  setCommittedOrders(
    ctx: StateContext<CommittedOrdersStateModel>,
    { payload }: SetCommittedOrders
  ) {
    ctx.setState({ ...ctx.getState(), committedOrders: payload });
  }

  @Action(SetCommittedOrdersRequest)
  setCommittedOrderRequest(ctx: StateContext<CommittedOrdersStateModel>, { payload }: SetCommittedOrdersRequest) {
    ctx.setState({ ...ctx.getState(), committedOrdersRequest: payload });
  }
  
  @Selector()
  static CommittedOrders(state: CommittedOrdersStateModel) {
    return state.committedOrders;
  }
  @Selector()
  static CommittedOrdersRequest(state: CommittedOrdersStateModel) {
    return state.committedOrdersRequest;
  }
}
